module.exports = __webpack_public_path__ + "static/media/6acd8ee3-d80a-44a0-a99e-11a7ed1d4cc4.169d0832.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/6acd8ee3-d80a-44a0-a99e-11a7ed1d4cc4.ttf
// module id = 106
// module chunks = 0